import React from 'react';
import { Helmet } from 'react-helmet-async';
import { JsonLd } from './JsonLd';
import { resolvePageMetadata } from '../../seo/metadata';
import { buildPageStructuredData } from '../../seo/structured-data';

export const PageSeo = ({ page, slug, language, faqItems = [], noindex = false }) => {
  const metadata = resolvePageMetadata({ page, slug, language });

  if (!metadata) {
    return null;
  }

  const structuredData = buildPageStructuredData({ page, slug, language, faqItems });
  const robots = noindex ? 'noindex,nofollow' : metadata.robots;

  return (
    <>
      <Helmet htmlAttributes={{ lang: language === 'fa' ? 'fa' : 'en' }}>
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.description} />
        {metadata.keywords ? <meta name="keywords" content={metadata.keywords} /> : null}
        <meta name="robots" content={robots} />
        <link rel="canonical" href={metadata.canonical} />

        <link rel="alternate" hrefLang="en" href={metadata.alternates.en} />
        <link rel="alternate" hrefLang="fa" href={metadata.alternates.fa} />
        <link rel="alternate" hrefLang="x-default" href={metadata.alternates['x-default']} />

        <meta property="og:title" content={metadata.title} />
        <meta property="og:description" content={metadata.description} />
        <meta property="og:url" content={metadata.canonical} />
        <meta property="og:type" content={metadata.ogType} />
        <meta property="og:site_name" content={metadata.siteName} />
        <meta property="og:locale" content={language === 'fa' ? 'fa_IR' : 'en_US'} />
        <meta property="og:locale:alternate" content={language === 'fa' ? 'en_US' : 'fa_IR'} />
        <meta property="og:image" content={metadata.ogImage} />

        <meta name="twitter:card" content={metadata.twitterCard} />
        <meta name="twitter:title" content={metadata.title} />
        <meta name="twitter:description" content={metadata.description} />
        <meta name="twitter:image" content={metadata.ogImage} />
      </Helmet>

      {structuredData.length ? <JsonLd data={structuredData} /> : null}
    </>
  );
};
